import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const withCredentialsConfig = { withCredentials: true };

export const createCheckoutSession = async (plan = 'basic') => {
  if (!BACKEND_URL) {
    throw new Error('Backend URL not configured');
  }

  const { data } = await axios.post(
    `${BACKEND_URL}/api/membership/checkout-session`,
    { plan },
    withCredentialsConfig
  );

  return data;
};

export const createPortalSession = async () => {
  if (!BACKEND_URL) {
    throw new Error('Backend URL not configured');
  }

  const { data } = await axios.post(
    `${BACKEND_URL}/api/membership/portal-session`,
    {},
    withCredentialsConfig
  );

  return data;
};

export const fetchMembershipStatus = async () => {
  if (!BACKEND_URL) {
    throw new Error('Backend URL not configured');
  }

  const { data } = await axios.get(
    `${BACKEND_URL}/api/membership/status`,
    withCredentialsConfig
  );

  return data;
};

export const upgradeMembership = async (plan) => {
  if (!BACKEND_URL) {
    throw new Error('Backend URL not configured');
  }

  const { data } = await axios.post(
    `${BACKEND_URL}/api/membership/upgrade`,
    { plan },
    withCredentialsConfig
  );

  return data;
};
